import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
const CHECKOUT_URL = 'https://brain-dump-system.impultienda.ar/checkout';
const TARGET_HREF = {
  offer: '#offer',
  inside: '#inside',
  checkout: CHECKOUT_URL
} as const;
interface CtaButtonProps {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
  /** 'checkout' opens the checkout page, the others scroll to a section. */
  target?: 'offer' | 'inside' | 'checkout';
  variant?: 'primary' | 'outline';
}
export function CtaButton({
  label,
  className = '',
  size = 'lg',
  target = 'checkout',
  variant = 'primary'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-sm sm:px-9 sm:text-base' : 'px-6 py-3 text-sm';
  const isCheckout = target === 'checkout';
  const styling = variant === 'primary' ? 'bg-brand-gold text-brand-deep shadow-lg shadow-[#2b1d15]/20 hover:-translate-y-0.5 hover:bg-[#f2cb72] hover:shadow-xl focus-visible:ring-brand-gold/50' : 'border-2 border-current bg-transparent hover:-translate-y-0.5 hover:bg-white/10 focus-visible:ring-current/40';
  return <a href={TARGET_HREF[target]} onClick={isCheckout ? trackCheckoutStart : undefined} className={`inline-flex items-center justify-center rounded-full font-body font-black uppercase tracking-[0.04em] transition duration-200 focus:outline-none focus-visible:ring-4 ${styling} ${sizing} ${className}`} data-id="element-1" data-mp="39xzjs619o0ub">
      {label}
    </a>;
}